import React, { type ComponentType, useLayoutEffect } from 'react';
import { getBrowserMetricsEventId } from '@atlassian/jira-forge-ui-analytics/src/common/utils';
import { forgeModulesConcurrentLoadTime } from '@atlassian/jira-forge-ui-analytics/src/common/utils/performance-analytics/main';

export const withRenderingMetrics =
	<P extends {}>(Component: ComponentType<P>, concurrentMetricsId: string): ComponentType<P> =>
	(props: P) => {
		const startTime = performance.now();
		// useLayoutEffect aligns more closely with react profiler's rendering time than useEffect (after paint).
		useLayoutEffect(() => {
			const eventId = getBrowserMetricsEventId({
				module: 'jira:customField',
				entryPoint: 'view',
				forgeUiType: 'native-ui',
			});

			const stopTime = performance.now();
			forgeModulesConcurrentLoadTime(concurrentMetricsId).start({ startTime });
			forgeModulesConcurrentLoadTime(concurrentMetricsId).stop({
				stopTime,
				customData: { eventId },
			});
			// eslint-disable-next-line react-hooks/exhaustive-deps -- startTime changes on every rerender, but we only want to send the metrics once
		}, []);

		return <Component {...props} />;
	};
